<template>
  <el-config-provider :locale="zhCn">
    <WordDefinition />
    <!-- 全局题库综合指南弹窗：任意页面通过 emitter 事件 open-question-guide 唤起 -->
    <QuestionGuideGlobal />
    <RouterView />
    <PrivacyConsent />
  </el-config-provider>
</template>

<script setup lang="ts">
import { dayjs, ElMessage, ElMessageBox } from 'element-plus'
import { zhCn } from 'element-plus/es/locale/index.mjs'
import { onBeforeUnmount, onMounted, provide, reactive } from 'vue'
import { RouterView } from 'vue-router'
import { useConfigStore } from '@/store/config.store'
import { useNavHoverStore } from '@/store/navHover.store'
import { workTimeOrCountApi } from './api/common.api'
import WordDefinition from '@/components/WordDefinition.vue'
import PrivacyConsent from '@/components/privacy-consent/index.vue'
import QuestionGuideGlobal from '@/components/QuestionGuideDialog/QuestionGuideGlobal.vue'
import { isSupportedBrowser } from '@/utils/browser'
import { useActiveTimeReport } from '@/composables/useActiveTimeReport'
import { useAnniversaryActiveTimeReport } from '@/composables/useAnniversaryActiveTimeReport'
import { fetchLocation, isChina, locationInfo } from '@/utils/location'
import { initCrossTabSync } from '@/utils/crossTabSync'
if (!window.localStorage.getItem('token')) {
  localStorage.setItem('LearningDuration', '{}')
}
const duration = reactive(JSON.parse(localStorage.getItem('LearningDuration') ?? '{}'))
provide('duration', duration)
onBeforeUnmount(() => clearInterval(tick))
const isChinaValue = isChina
provide('isChina', isChinaValue)

// 获取用户当前位置，根据位置弹框提示用户是否需要切换域名
const getLocation = () => {
  fetchLocation().then(() => {
    const data = locationInfo.value
    if (data) {
      const city = data.city || ''
      const host: string = window.location.host
      let text = ''
      if (
        isChinaValue.value &&
        ['pte-api.ytaxx.com', 'haiwai.ytaxx.com', 'https://www-singapore.ytaxx.com'].includes(host)
      ) {
        text = `您当前所在位置为${city}，建议切换到 大陆站 继续访问。`
      } else if (!isChinaValue.value && host === 'ytaxx.com') {
        text = `您当前所在位置为${city}，建议切换到国际站继续访问。`
      } else {
        return
      }
      if (text) {
        ElMessageBox.alert(text, '提示', {
          center: true,
          lockScroll: false,
          showCancelButton: true
        }).then((res) => {
          if (res === 'confirm') {
            if (isChinaValue.value) {
              window.location.href = `https://ytaxx.com/?token=${window.localStorage.getItem('token')}`
            } else {
              window.location.href = `https://www-singapore.ytaxx.com/?token=${window.localStorage.getItem('token')}`
            }
          }
        })
      }
    }
  })
}
let tick: string | number | NodeJS.Timeout | undefined
let rq_timer: string | number | NodeJS.Timeout | undefined
useActiveTimeReport()
// 9 周年庆活动学习时长上报（与新人福利上报相互独立）
useAnniversaryActiveTimeReport()
// 跨窗口状态同步：其他窗口登录 / 退出登录 / 会员状态更新时，自动刷新本窗口同步数据
initCrossTabSync()

onMounted(() => {
  console.log('App ', isSupportedBrowser())
  if (!isSupportedBrowser()) {
    ElMessage.warning('复制网址前往谷歌、火狐、Edge、Safari等浏览器体验更流畅')
  }
  clearTimeout(rq_timer)
  // 进入官网即预取导航 hover 数据（全题库/高频库弹窗）存入缓存，刷新页面重新拉取更新
  useNavHoverStore().init()
  getLocation()
  rq_timer = window.setTimeout(() => {
    const timeOrCount = workTimeOrCountApi()
    // 统计学习时间
    tick = window.setInterval(() => {
      if (!window.localStorage.getItem('token')) {
        return
      }
      Object.assign(duration, JSON.parse(localStorage.getItem('LearningDuration') ?? '{}'))
      if (duration.updateTime && dayjs().isSame(duration.updateTime, 'm')) return
      const date = dayjs().format('YYYY-MM-DD')
      if (date === duration.date) {
        duration.today++
        timeOrCount.countTime(60)
      } else {
        duration.today = 0
        duration.date = date
      }
      duration.total++
      duration.updateTime = new Date().valueOf()
      localStorage.setItem('LearningDuration', JSON.stringify(duration))
    }, 60000)
    useConfigStore().getNewWxInfoApi() //获取回流二维码
  }, 1000)
})
</script>

<style lang="scss"></style>
